"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../../components/Button/Button"));
const Icon_1 = __importDefault(require("../../components/Icon/Icon"));
const CloseSmall_1 = __importDefault(require("../../components/Icon/Icons/components/CloseSmall"));
const AlertBannerConstants_1 = require("./AlertBannerConstants");
const function_utils_1 = require("../../utils/function-utils");
require("./AlertBanner.scss");
const AlertBanner = (0, react_1.forwardRef)(({ children: originalChildren, className, backgroundColor = AlertBanner.backgroundColors.PRIMARY, onClose = function_utils_1.NOOP, ariaLabel = "", isCloseHidden = false }, ref) => {
    const classNames = (0, react_1.useMemo)(() => {
        return (0, classnames_1.default)(className, "monday-alert-banner", `monday-alert-banner--background-color-${backgroundColor}`);
    }, [className, backgroundColor]);
    const isDarkBackground = backgroundColor === AlertBanner.backgroundColors.DARK;
    const children = (0, react_1.useMemo)(() => {
        const allChildren = react_1.default.Children.toArray(originalChildren);
        const filteredChildren = allChildren.filter((child) => {
            // @ts-ignore displayName & isAlertBannerItem is coming from child assigned field: AlertBannerButton, AlertBannerLink, AlertBannerText
            if (child.type.isAlertBannerItem || child.type.displayName === "MDXCreateElement")
                return true;
            console.error("Alert banner child is not supported. Please use AlertBannerText, AlertBannerLink or AlertBannerButton.", child);
            return false;
        });
        return filteredChildren.map((child, index) => {
            return react_1.default.cloneElement(child, Object.assign(Object.assign({}, child === null || child === void 0 ? void 0 : child.props), { marginLeft: index > 0, isDarkBackground }));
        });
    }, [originalChildren, isDarkBackground]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref, className: classNames, role: "banner", "aria-label": ariaLabel || "banner" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "monday-alert-banner__inner" }, { children: children.map((child, index) => {
                    // @ts-ignore isAlertBannerItem is coming from child assigned field: AlertBannerButton, AlertBannerLink, AlertBannerText
                    const childTypeIsAlertBannerText = child.type.isAlertBannerText;
                    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)("monday-alert-banner__inner-item", {
                            "monday-alert-banner__inner-item-text": childTypeIsAlertBannerText
                        }) }, { children: childTypeIsAlertBannerText ? (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "monday-alert-banner__ellipsis" }, { children: child })) : child }), index));
                }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "monday-alert-banner__close-button-wrapper" }, { children: isCloseHidden ? null : ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ className: "monday-alert-banner__alert-banner-close-btn", onClick: onClose, size: Button_1.default.sizes.SMALL, kind: Button_1.default.kinds.TERTIARY, color: isDarkBackground ? Button_1.default.colors.ON_INVERTED_BACKGROUND : Button_1.default.colors.ON_PRIMARY_COLOR, ariaLabel: "close-toast" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: Icon_1.default.type.SVG, clickable: false, icon: CloseSmall_1.default, iconSize: "20px", ignoreFocusStyle: true }) }))) }))] })));
});
Object.assign(AlertBanner, {
    backgroundColors: AlertBannerConstants_1.AlertBannerBackgroundColor
});
exports.default = AlertBanner;
